/**
 * Format Price
 * @param {*} price number 
 * @returns number
 */

/**
 * Description:
 * Takes a number and returns it formated with dots.
 * Im using es-CL because the site is for Chile.
 * Ej: Input 1400 - Output 1.400
 */

const formatPrice = (price) => {
    return price?.toLocaleString("es-CL");
}

export {
    formatPrice
}